import { timeKeyForMinute } from './timelineLogic.js';
import { sortHorsesForSpectrum } from './spectrumSort.js';

export const DOUBLE_DB_RED_BG = 'rgb(255 154 154)';

function getLatestOvernightTimeKey(horse) {
  const keys = Object.keys(horse?.time_series || {})
    .filter((key) => {
      const minute = parseInt(String(key).split('_')[1], 10);
      return !Number.isNaN(minute) && minute > 720;
    })
    .sort((a, b) => parseInt(b.split('_')[1], 10) - parseInt(a.split('_')[1], 10));
  return keys[0] || null;
}

function getTimeSeriesAtView(horse, viewMinute, overnightActive) {
  if (!horse) return null;
  if (overnightActive) {
    const key = getLatestOvernightTimeKey(horse);
    return key ? horse.time_series?.[key] : null;
  }
  const tk = timeKeyForMinute(viewMinute);
  return horse.time_series?.[tk] || null;
}

/** 与 HorseTable.getTimeOdds 一致：孖冠/孖亚优先当前视图分钟 time_series */
export function getHorseTimeOdds(horse, field, viewMinute, overnightActive) {
  const base = horse?.odds || {};
  if (field === 'double_up') {
    return base.double_up;
  }
  if (field === 'double_down') {
    const ts = getTimeSeriesAtView(horse, viewMinute, overnightActive);
    if (ts && Object.prototype.hasOwnProperty.call(ts, 'double_down')) {
      const v = Number(ts.double_down);
      if (!Number.isNaN(v) && v > 0) return ts.double_down;
    }
    return null;
  }
  const ts = getTimeSeriesAtView(horse, viewMinute, overnightActive);
  if (ts && ts[field] != null && ts[field] !== '') {
    const n = Number(ts[field]);
    if (!Number.isNaN(n) && n >= 0) return ts[field];
  }
  return base[field];
}

function toComparableOdds(raw) {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function doubleDbBackgroundColor(value, index, sorted, field, viewMinute, overnightActive) {
  const cur = toComparableOdds(value);
  if (cur == null || index <= 1) return 'transparent';
  const prev = toComparableOdds(getHorseTimeOdds(sorted[index - 1], field, viewMinute, overnightActive));
  const prevPrev = toComparableOdds(getHorseTimeOdds(sorted[index - 2], field, viewMinute, overnightActive));
  if (prev != null && prevPrev != null && cur < prev && cur < prevPrev) {
    return DOUBLE_DB_RED_BG;
  }
  if (prev != null && cur < prev) {
    return 'rgba(255, 255, 200, 0.5)';
  }
  return 'transparent';
}

export function getDoubleWinBackgroundColor(value, index, horses, sortBy, viewMinute, overnightActive) {
  const sorted = sortHorsesForSpectrum(horses, sortBy, { viewMinute, overnightActive });
  return doubleDbBackgroundColor(value, index, sorted, 'double_win', viewMinute, overnightActive);
}

export function getDoubleSecondBackgroundColor(value, index, horses, sortBy, viewMinute, overnightActive) {
  const sorted = sortHorsesForSpectrum(horses, sortBy, { viewMinute, overnightActive });
  return doubleDbBackgroundColor(value, index, sorted, 'double_second', viewMinute, overnightActive);
}

export function isDoubleDbRedBackground(bg) {
  return bg === DOUBLE_DB_RED_BG;
}

export function horseNumRedForDoubleDbAnomaly(horse, index, horses, sortBy, viewMinute, overnightActive) {
  const dw = getHorseTimeOdds(horse, 'double_win', viewMinute, overnightActive);
  const ds = getHorseTimeOdds(horse, 'double_second', viewMinute, overnightActive);
  return isDoubleDbRedBackground(getDoubleWinBackgroundColor(dw, index, horses, sortBy, viewMinute, overnightActive))
    || isDoubleDbRedBackground(getDoubleSecondBackgroundColor(ds, index, horses, sortBy, viewMinute, overnightActive));
}
